(function () {
  const Core = window.RB.Core;

  const W = {
    win: 1e9,
    point: 1200,
    myPoint: 60,
    bfControl: 90,
    bfContest: 30,
    unitBase: 10,
    unitMight: 7,
    unitAtBf: 8,
    handCard: 5,
    rune: 4,
    burnRisk: 40,
    stunned: 6,
  };

  function evaluate(state, me) {
    if (state.over) return state.over.winner === me ? W.win : -W.win;
    const opp = Core.otherPlayer(me);
    const P = state.players;
    let v = 0;
    v += (P[me].points - P[opp].points) * W.point;
    v += P[me].points * W.myPoint;
    for (const bfIid of state.battlefields) {
      const bf = state.objs[bfIid];
      if (bf.controller === me) v += W.bfControl;
      else if (bf.controller === opp) v -= W.bfControl;
      if (bf.contestedBy === me) v += W.bfContest;
      else if (bf.contestedBy === opp) v -= W.bfContest;
    }
    for (const iid of Core.boardObjs(state)) {
      const o = state.objs[iid];
      if (o.attachedTo || !Core.isType(state, iid, "unit")) continue;
      const m = Core.effMight(state, iid) || 0;
      let uv = W.unitBase + m * W.unitMight;
      if (o.loc && o.loc.t === "bf") uv += W.unitAtBf;
      if (o.stunned) uv -= W.stunned;
      v += o.controller === me ? uv : -uv;
    }
    v += (P[me].hand.length - P[opp].hand.length) * W.handCard;
    let myRunes = 0, oppRunes = 0;
    for (const iid of Core.boardObjs(state)) {
      if (!Core.isType(state, iid, "rune")) continue;
      if (state.objs[iid].controller === me) myRunes++;
      else oppRunes++;
    }
    v += (myRunes - oppRunes) * W.rune;
    if (P[me].mainDeck.length < 4) v -= (4 - P[me].mainDeck.length) * W.burnRisk;
    return v;
  }

  function defaultPick(state, acts) {
    const pd = state.pending;
    if (pd.kind === "pay") {
      return acts.find(function (a) { return a.type === "PAY" && a.auto; })
        || acts.find(function (a) { return a.type === "PAY"; })
        || acts[0];
    }
    return acts[0];
  }

  function rollout(state, me, ctl, depth) {
    let guard = 0;
    while (!state.over && state.pending && guard++ < 60 && ctl.nodes < ctl.maxNodes) {
      const pd = state.pending;
      if (pd.player === me && (pd.kind === "act" || pd.kind === "focus" || pd.kind === "respond")) break;
      if (pd.player !== me) {
        if (pd.kind === "focus" || pd.kind === "respond") {
          ctl.nodes++;
          try { Kernel.step(state, { type: "PASS", player: pd.player }); } catch (e) { break; }
          continue;
        }
        break;
      }
      const acts = Kernel.enumerateActions(state);
      if (!acts.length) break;
      let pick;
      if (acts.length === 1) {
        pick = acts[0];
      } else if (pd.kind === "pay") {
        pick = defaultPick(state, acts);
      } else if (depth > 0 && acts.length <= 24) {
        let best = null, bestScore = -Infinity;
        for (const a of acts) {
          if (ctl.nodes >= ctl.maxNodes) break;
          ctl.nodes++;
          const s2 = Kernel.snapshot(state);
          try { Kernel.step(s2, a); } catch (e) { continue; }
          rollout(s2, me, ctl, depth - 1);
          const sc = evaluate(s2, me);
          if (sc > bestScore) { bestScore = sc; best = a; }
        }
        pick = best || defaultPick(state, acts);
      } else {
        pick = defaultPick(state, acts);
      }
      ctl.nodes++;
      try { Kernel.step(state, pick); } catch (e) { break; }
    }
    return state;
  }

  function mulliganAction(state) {
    const pd = state.pending;
    const p = pd.player;
    const hand = state.players[p].hand;
    const toss = [];
    for (const iid of hand) {
      const c = Core.card(state, iid);
      if (c && (c.energy || 0) >= 6 && toss.length < 2) toss.push(iid);
    }
    return { type: "MULLIGAN", player: p, cards: toss };
  }

  const Brain = {
    evaluate: evaluate,

    chooseAction(live) {
      const pd = live.pending;
      if (!pd || live.over) return null;
      const me = pd.player;
      if (pd.kind === "manual") return { type: "CONTINUE", player: me };
      if (pd.kind === "mulligan") return mulliganAction(live);

      const state = Object.assign({}, live, { gameLog: [] });

      let acts = Kernel.enumerateActions(state);
      if (!acts.length) return null;
      if (acts.length === 1) return acts[0];
      if (pd.kind === "pay") return defaultPick(state, acts);
      if (pd.kind === "choose") acts = acts.filter(function (a) { return a.type !== "CANCEL"; });
      if (acts.length > 150) acts = acts.slice(0, 150);

      const ctl = { nodes: 0, maxNodes: 4000 };
      let best = null, bestScore = -Infinity;
      for (let i = 0; i < acts.length; i++) {
        const a = acts[i];
        if (ctl.nodes >= ctl.maxNodes && best) break;
        ctl.nodes++;
        const r = Kernel.tryStep(state, a);
        if (!r.ok) continue;
        rollout(r.state, me, ctl, 1);
        const sc = evaluate(r.state, me) - i * 0.001;
        if (sc > bestScore) { bestScore = sc; best = a; }
      }
      return best || defaultPick(state, acts);
    },
  };

  window.RB = window.RB || {};
  window.RB.Brain = Brain;
})();
